import NorthEastRoundedIcon from "@mui/icons-material/NorthEastRounded";
import SouthEastRoundedIcon from "@mui/icons-material/SouthEastRounded";
import type { SvgIconProps } from "@mui/material/SvgIcon";
import type { FC } from "react";

import { ChartViewEnum } from "~/feature/chart/types";

import { LogoMarkIcon } from "./LogoMarkIcon";

export const labelByChartViewEnum: Record<ChartViewEnum, string> = {
  [ChartViewEnum.YES]: "Yes",
  [ChartViewEnum.NO]: "No",
  [ChartViewEnum.BOTH]: "Both",
  [ChartViewEnum.CONSENSUS]: "PH Consensus",
};

export const CONSENSUS_UNAVAILABLE_TOOLTIP =
  "Available only for markets listed on more than one platform — there is nothing to compare across a single one.";

export const iconByChartViewEnum: Partial<
  Record<ChartViewEnum, FC<SvgIconProps>>
> = {
  [ChartViewEnum.YES]: NorthEastRoundedIcon,
  [ChartViewEnum.NO]: SouthEastRoundedIcon,
  [ChartViewEnum.CONSENSUS]: LogoMarkIcon,
};
